var _circle, _circle2, _circle3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E2B421"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9448,
    cy: 13.9446,
    r: 12.8379,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9446,
    cy: 13.9447,
    r: 11.8419,
    fill: "#E2B421"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5776 7.13784C15.667 5.79684 19.6867 8.08529 20.8036  11.7934C21.0016 12.4509 21.105 13.1591 21.1167 13.8462C21.155 16.1129  21.1311 18.3806 21.1311 20.6478C21.1311 20.7814 21.1311 20.9149 21.1311  21.0828C20.4117 21.0828 19.7095 21.0828 18.9622 21.0828C18.9622 20.4641  18.9622 19.8427 18.9622 19.2193C18.3369 19.6198 17.7729 20.0542 17.1485  20.369C12.7058 22.609 7.35987 19.7195 6.78131 14.7807C6.75487 14.555  6.75268 14.3255 6.75248 14.0978C6.75048 11.8037 6.75125 9.50959 6.75124  7.21547C6.75124 7.08268 6.75124 6.94989 6.75124 6.78619C7.47711 6.78619  8.17895 6.78619 8.92635 6.78619C8.92635 7.41458 8.92635 8.03527 8.92635  8.74827C9.7514 8.01816 10.5858 7.47486 11.5776 7.13784ZM10.5819  10.2184C8.46862 12.0803 8.35933 15.385 10.3429 17.4445C12.2704 19.4458  15.5974 19.448 17.5348 17.4493C19.4339 15.4902 19.4372 12.4617 17.5424  10.4398C15.752 8.52919 12.6675 8.41305 10.5819 10.2184Z",
    fill: "#FFFEFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1849 10.9837C14.3033 9.79269 16.872 10.9775 17.3049  13.2864C17.5572 14.6322 17.1325 15.7891 16.0366 16.6326C14.9418 17.4753  13.7097 17.5987 12.4676 17.0152C11.2402 16.4386 10.5716 15.4279 10.5171  14.0622C10.464 12.7311 11.0551 11.7253 12.1849 10.9837Z",
    fill: "#FFFFFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbey);
export default __webpack_public_path__ + "static/media/Abey.88377680f581895a4f0f0fa40c2e5276.svg";
export { ForwardRef as ReactComponent };